// TODO: REFACTORING
import React, { useState } from 'react';
import Style from './style.module.css';
import { translate as t } from '../../utils/translate';
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share';
import {
  EmailIcon,
  FacebookIcon,
  LinkedinIcon,
  TelegramIcon,
  TwitterIcon,
  WhatsappIcon,
} from 'react-share';

const ShareButton = ({ url }) => {
  const TEXTS = {
    SHARE: t('share'),
  };
  const [shareActive, setShareActive] = useState(false);

  const shareIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13.443"
      height="17.924"
      viewBox="0 0 13.443 17.924"
    >
      <g transform="translate(-68.891 0)">
        <path
          fill="#192a41"
          d="M81.774,172.228h-1.68v1.12h1.12V183.43h-11.2V173.348h1.12v-1.12h-1.68a.56.56,0,0,0-.56.56v11.2a.56.56,0,0,0,.56.56H81.774a.56.56,0,0,0,.56-.56v-11.2A.56.56,0,0,0,81.774,172.228Z"
          transform="translate(0 -166.627)"
        />
        <path
          className={Style.movingPart}
          fill="#192a41"
          d="M163.248,2.144v7.938h1.12V2.144l2.4,2.4.792-.792L163.808,0l-3.757,3.757.792.792Z"
          transform="translate(-88.195 0)"
        />
      </g>
    </svg>
  );

  const link = url
    ? url
    : typeof window !== 'undefined'
    ? window.location.href
    : '';

  return (
    <div className={Style.share}>
      {!shareActive && (
        <div onClick={() => setShareActive(true)}>
          {shareIcon}
          <span>{TEXTS.SHARE}</span>
        </div>
      )}
      {shareActive && (
        <div className={Style.shareOptions}>
          <EmailShareButton url={link}>
            <EmailIcon />
          </EmailShareButton>
          <FacebookShareButton url={link}>
            <FacebookIcon />
          </FacebookShareButton>
          <LinkedinShareButton url={link}>
            <LinkedinIcon />
          </LinkedinShareButton>
          <TelegramShareButton url={link}>
            <TelegramIcon />
          </TelegramShareButton>
          <TwitterShareButton url={link}>
            <TwitterIcon />
          </TwitterShareButton>
          <WhatsappShareButton url={link}>
            <WhatsappIcon />
          </WhatsappShareButton>
        </div>
      )}
    </div>
  );
};

export default ShareButton;
